module.exports = __webpack_public_path__ + "img/sumSign.263c2121.svg";